import EConsentByGuidProvider from "@/components/providers/form/EConsentByGuidProvider";
import { OnlinePatientManagementContext, RouteLoading } from "@ngt/opms";
import { FC, PropsWithChildren, useContext } from "react";
import { useParams } from "react-router";

export interface IEConsentByGuidRouteProps extends PropsWithChildren {
    formDefinitionCode?: string;
    guid?: string;
    
    /**
     * This property determines whether the associated data should be loaded before loading the route.
     */
    loadBeforeMount?: boolean;
}


const EConsentByGuidRoute: FC<IEConsentByGuidRouteProps> = ({
    formDefinitionCode,
    guid,

    loadBeforeMount,

    children
}) => {
    const params = useParams();
    const { routeParameters } = useContext(OnlinePatientManagementContext);

    const guidToUse = params.guid ?? guid ?? undefined;
    const formDefinitionIdentifierToUse = params[routeParameters.formDefinitionCode] ?? formDefinitionCode ?? undefined;
    
    return (
        <EConsentByGuidProvider
            guid={guidToUse}
            formDefinitionIdentifier={formDefinitionIdentifierToUse}

            loadBeforeMount={loadBeforeMount}
            LoadingComponent={RouteLoading}
        >
            {children}
        </EConsentByGuidProvider>
    );
}

export default EConsentByGuidRoute;
